import { render, staticRenderFns } from "./CourseAdminView.vue?vue&type=template&id=3b6582be&scoped=true&"
import script from "./CourseAdminView.vue?vue&type=script&lang=ts&"
export * from "./CourseAdminView.vue?vue&type=script&lang=ts&"
import style0 from "./CourseAdminView.vue?vue&type=style&index=0&id=3b6582be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6582be",
  null
  
)

export default component.exports